module.exports = __webpack_public_path__ + "img/sacolas.ee84dfab.jpg";